export const essexDigitalMarketingAreas = [
  "Chelmsford",
  "Brentwood",
  "Braintree",
  "Colchester",
  "Basildon",
  "Southend-on-Sea",
  "Maldon",
  "Witham",
  "Harlow",
  "Epping",
  "Rayleigh",
]

export const digitalMarketingFaqs = [
  {
    question: "What does your digital marketing service include?",
    answer:
      "The right mix depends on the business and its customers. Our work can include marketing strategy, SEO, local search, content, paid campaigns, social media, email, landing pages, conversion improvements and reporting. We prioritise the channels most likely to support your commercial goals rather than prescribing every service.",
  },
  {
    question: "Do you provide digital marketing for businesses across Essex?",
    answer:
      "Yes. Web Wonderland is based in Chelmsford and works with businesses throughout Essex, including Brentwood, Braintree, Colchester, Basildon, Southend-on-Sea, Maldon, Witham, Harlow, Epping and Rayleigh. We also support organisations elsewhere in the UK.",
  },
  {
    question: "Can you help an Essex business improve its local SEO?",
    answer:
      "Yes. Local SEO work can include service-page structure, location signals, Google Business Profile guidance, technical improvements, internal links, useful local content and measurement. Recommendations are based on the searches and locations that are commercially relevant to the business.",
  },
  {
    question: "Should we invest in SEO or paid advertising first?",
    answer:
      "It depends on your timescale, market, website and budget. Paid campaigns can create faster visibility, while SEO usually builds value over a longer period. Many businesses benefit from using paid activity for immediate demand while improving the website and organic search foundations in parallel.",
  },
  {
    question: "Do you create content and manage social media?",
    answer:
      "Yes. We can plan themes, write and design content, create campaign assets, organise publishing schedules and support paid or organic social activity. The work is connected to an agreed audience, message and next step so it serves a commercial purpose.",
  },
  {
    question: "How do you measure digital marketing performance?",
    answer:
      "We agree useful measures before delivery begins. Depending on the campaign, these can include qualified enquiries, calls, sales, cost per lead, conversion rate, organic visibility and engagement with priority content. Reporting should help decide what to improve next, not simply list activity.",
  },
  {
    question: "Can you work alongside our internal marketing team?",
    answer:
      "Yes. We can provide strategy, specialist delivery or additional capacity around an existing team. That might mean owning a defined campaign, improving the website and analytics, producing content, or supporting channels your team does not manage internally.",
  },
  {
    question: "Do you offer one-off projects and ongoing marketing support?",
    answer:
      "Yes. Some businesses need an audit, strategy or campaign, while others need continued delivery and optimisation. We will recommend a practical scope based on the work required and explain what can be handled as a project or ongoing programme.",
  },
]
